import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import FlatButton from '../buttons/flat_button'
import Logo from '../../images/logo.png'
import LogoWhite from '../../images/logo_white.png'
import { scrollToElement } from '../../pages/landing/components/scroll_utils'
import { useAuth } from '../../hooks/auth/use_auth'

const ADDRESS = '〒650-0035 兵庫県神戸市中央区浪花町56 KiP内'
const TEL = '050-1808-4630'
const MAIL = 'cs@the-lodges.jp'

interface GuestLayoutProps {
  children: React.ReactNode
}

const GuestLayout: React.FC<GuestLayoutProps> = ({ children }) => {
  const navigate = useNavigate()
  const [openHamMenu, setOpenHamMenu] = useState(false)
  const { user, initialize } = useAuth()

  useEffect(() => {
    initialize()
  }, [initialize])

  const scrollToSection = (sectionId: string) => {
    const currentPath = window.location.pathname

    if (currentPath !== '/') {
      // LP以外にいる場合は、まず'/'に遷移
      navigate('/')
      sessionStorage.setItem('scrollToSection', sectionId)
    } else {
      // LPにいる場合は直接スクロール
      if (scrollToElement(sectionId)) {
        setOpenHamMenu(false)
      }
    }
  }

  const transferFormPage = () => {
    const url = 'https://forms.gle/adLPrUPYo5GHtTbZA'
    window.open(url, '_blank')
  }

  return (
    <>
      {/* ハンバーガーメニュー */}
      <div
        id="ham_btn"
        onClick={() => setOpenHamMenu(!openHamMenu)}
        className={openHamMenu ? 'open' : ''}
      >
        <span className={!openHamMenu ? '!bg-main-green' : ''}></span>
        <span className={!openHamMenu ? '!bg-main-green' : ''}></span>
        <span className={!openHamMenu ? '!bg-main-green' : ''}></span>
        {!openHamMenu && <div className="message !text-main-green">menu</div>}
        {openHamMenu && <div className="message">close</div>}
      </div>

      {/* ハンバーガーメニュー */}
      <div
        className={`w-screen h-screen z-20 bg-main-green fixed top-0 left-0 ${openHamMenu ? 'block' : 'hidden'}`}
      >
        <div className="text-center w-11/12 pt-24 mx-auto">
          <a
            className="block mb-4 text-white font-bold"
            onClick={() => scrollToSection('landing')}
          >
            TOP
          </a>
          <a
            className="block mb-4 text-white font-bold"
            onClick={() => scrollToSection('features')}
          >
            サービスの特徴
          </a>
          <a
            className="block mb-4 text-white font-bold"
            onClick={() => scrollToSection('solution')}
          >
            課題解決
          </a>
          <a
            className="block mb-4 text-white font-bold"
            onClick={() => scrollToSection('five-steps')}
          >
            共創の5ステップ
          </a>
          <a
            className="block mb-4 text-white font-bold"
            onClick={() => scrollToSection('vision')}
          >
            ビジョン
          </a>
          <a
            className="block mb-4 text-white font-bold"
            onClick={() => navigate('/faq')}
          >
            よくある質問
          </a>
          <a
            className="block mb-8 text-white font-bold"
            onClick={() => scrollToSection('plan')}
          >
            料金プラン
          </a>
          <FlatButton
            className="!bg-main-black mx-auto"
            onClick={() => transferFormPage()}
          >
            今すぐ資料をダウンロード
          </FlatButton>
          <div className="border-t border-dashed border-white mx-auto my-8 w-80"></div>
          {user ? (
            <FlatButton
              className="!bg-main-black mx-auto mb-4"
              onClick={() => navigate('/dashboard')}
            >
              共創ダッシュボード
            </FlatButton>
          ) : (
            <>
              <FlatButton
                className="!bg-main-black mx-auto mb-4"
                onClick={() => navigate('/login')}
              >
                ログイン
              </FlatButton>
              <FlatButton
                className="mx-auto"
                onClick={() => navigate('/register/mail/send')}
                outline
              >
                会員登録
              </FlatButton>
            </>
          )}
        </div>
        <img
          src={LogoWhite}
          className="w-40 absolute bottom-8 right-0 left-0 mx-auto"
        />
      </div>

      {/* ヘッダー */}
      <header className="w-full py-2 bg-white hidden xl:block">
        <div className="w-11/12 flex justify-between mx-auto">
          {/* 左 */}
          <div className="flex items-center">
            <img src={Logo} alt="ロゴ" className="h-[60px] block mr-8" />

            <a
              className="mr-8 cursor-pointer text-sm 2xl:text-base"
              onClick={() => scrollToSection('landing')}
            >
              TOP
            </a>
            <a
              className="mr-8 cursor-pointer text-sm 2xl:text-base"
              onClick={() => scrollToSection('features')}
            >
              サービスの特徴
            </a>
            <a
              className="mr-8 cursor-pointer text-sm 2xl:text-base"
              onClick={() => scrollToSection('solution')}
            >
              課題解決
            </a>
            <a
              className="mr-8 cursor-pointer text-sm 2xl:text-base"
              onClick={() => scrollToSection('five-steps')}
            >
              共創の5ステップ
            </a>
            <a
              className="mr-8 cursor-pointer text-sm 2xl:text-base"
              onClick={() => scrollToSection('vision')}
            >
              ビジョン
            </a>
            <a
              className="mr-8 cursor-pointer text-sm 2xl:text-base"
              onClick={() => navigate('/faq')}
            >
              よくある質問
            </a>
            <a
              className="cursor-pointer text-sm 2xl:text-base"
              onClick={() => scrollToSection('plan')}
            >
              料金プラン
            </a>
          </div>

          {/* 右 */}
          <div className="flex items-center gap-4">
            <FlatButton
              className="bg-main-green my-1"
              onClick={() => transferFormPage()}
            >
              今すぐ資料をダウンロード
            </FlatButton>

            {user ? (
              <>
                <FlatButton
                  className="my-1"
                  onClick={() => navigate('/dashboard')}
                  outline
                >
                  共創ダッシュボード
                </FlatButton>
              </>
            ) : (
              <>
                <FlatButton
                  className="bg-main-green my-1"
                  onClick={() => navigate('/login')}
                >
                  ログイン
                </FlatButton>
                <FlatButton
                  className="my-1"
                  onClick={() => navigate('/register/mail/send')}
                  outline
                >
                  会員登録
                </FlatButton>
              </>
            )}
          </div>
        </div>
      </header>

      {/* メインコンテンツ */}
      <div id="landing" />
      {children}

      {/* フッター */}
      <footer className="bg-main-dimgray w-full py-20">
        <div className="w-11/12 mx-auto border border-white py-12 px-4 md:px-8 md:flex justify-between text-white md:mb-0 mb-8">
          {/* 左 */}
          <div>
            <img src={LogoWhite} className="w-40 block mb-12" />
            <div className="mb-8 hidden md:block">
              <p className="text-sm font-bold">Address:</p>
              <p className="text-sm">{ADDRESS}</p>
            </div>
            <div className="hidden md:block">
              <p className="text-sm font-bold">Contact:</p>
              <p className="text-sm">{TEL}</p>
              <p className="text-sm">{MAIL}</p>
            </div>
          </div>
          {/* 右 */}
          <div className="md:flex">
            <div className="md:w-[150px] md:mr-8">
              <a
                className="block w-full mb-4"
                onClick={() => scrollToSection('landing')}
              >
                TOP
              </a>
              <a
                className="block w-full mb-4"
                onClick={() => scrollToSection('features')}
              >
                サービスの特徴
              </a>
              <a
                className="block w-full mb-4"
                onClick={() => scrollToSection('solution')}
              >
                課題解決
              </a>
              <a
                className="block w-full mb-4"
                onClick={() => scrollToSection('five-steps')}
              >
                共創の5ステップ
              </a>
              <a
                className="block w-full mb-4"
                onClick={() => scrollToSection('vision')}
              >
                ビジョン
              </a>
              <a
                className="block w-full mb-4 cursor-pointer"
                onClick={() => navigate('/faq')}
              >
                よくある質問
              </a>
              <a
                className="block w-full mb-4"
                onClick={() => scrollToSection('plan')}
              >
                料金プラン
              </a>
            </div>
            <div className="md:w-[200px]">
              <a
                className="block w-full mb-4 cursor-pointer"
                onClick={() => navigate('/contact')}
              >
                お問合せ
              </a>
              <a
                className="block w-full mb-4"
                onClick={() => navigate('/policy/user')}
              >
                利用規約
              </a>
              <a
                className="block w-full mb-4"
                onClick={() => navigate('/policy/privacy')}
              >
                プライバシーポリシー
              </a>
              <a
                className="block w-full mb-8"
                onClick={() => navigate('/policy/law')}
              >
                特定商取引法に基づく表記
              </a>
              <FlatButton
                className="w-full xs:w-fit"
                onClick={() => transferFormPage()}
              >
                今すぐ資料をダウンロード
              </FlatButton>
            </div>
          </div>
          <div className="md:hidden pt-12">
            <div className="mb-4">
              <p className="font-bold">Address:</p>
              <p>{ADDRESS}</p>
            </div>
            <div>
              <p className="font-bold">Contact:</p>
              <p>{TEL}</p>
              <p>{MAIL}</p>
            </div>
          </div>
        </div>
      </footer>
      {process.env.REACT_APP_ENV !== 'production' && (
        <div className="fixed bottom-0 right-0 text-white p-2 w-screen z-50 text-center bg-slate-900/50">
          SDGs 共創
          Lodgeのテスト環境です。本番環境ではこの部分は表示されません。
        </div>
      )}
    </>
  )
}

export default GuestLayout
